<div class="fx-row align-items-center justify-content-between">
  <div class="fx-column">
    <span class="page-title">{{'CASES_LIST.TITLE' | translate}}</span>
    <span class="page-subtitle">{{'CASES_LIST.SUBTITLE' | translate}}</span>
  </div>
  <app-quota-bound-button quota="cases" *ngIf="!loading && done && !noDocs">
    <button class="main-button ml-20" routerLink="new" aclBasedElement resource="CASE" [scopes]="['C']">
      <div class="fx-row align-items-center justify-content-center">
        <mat-icon class="white mr-5" fontSet="material-icons-outlined">create_new_folder</mat-icon>
        {{'CASES_LIST.NEW' | translate}}
      </div>
    </button>
  </app-quota-bound-button>
</div>
<mat-divider class="mv-20"></mat-divider>
<div class="mb-10" *ngIf="!loading && done && !noDocs">
  <div class="fx-row align-items-center justify-content-between">
    <div class="fx-row align-items-center justify-content-start">
      <app-trademark-select label="{{'ENTITIES.TRADEMARK' | translate}}" [multiple]="true" [search]="true"
        initial="none" (change)="onTrademarkChange($event)" [(value)]="filters.trademark" [emitOnInit]="false"
        style="width:180px;"></app-trademark-select>
      <app-datepicker (change)="onDateChange($event)" class="ml-10"
        placeholder="{{'CASES_LIST.DATE_FILTER' | translate}}" [(value)]="this.filters.date"
        [optional]="true"></app-datepicker>
      <div class="fx-row fw-wrap align-items-baseline justify-content-start ml-10">
        <app-animated-number [value]="cases.totalDocs" [class]="'bold main'"></app-animated-number>
        &nbsp;
        <span class="text"><span class="bold main">{{((cases.totalDocs > 1 ? 'ENTITIES.CASES' :
            'ENTITIES.CASE') |
            translate).toLowerCase()}}</span> {{('UTILS.MATCHING' | translate).toLowerCase()}}</span>
      </div>
    </div>
    <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search" [(value)]="filters.query"
      (change)="onQueryChange($event)"></app-input>
  </div>
</div>
<div class="fx-row align-items-start justify-content-start" *ngIf="!loading && done && !noDocs">
  <div class="fx-row fx-wrap case-column fx-flex-50" *ngFor="let status of CASE_STATUS">
    <div class="fx-row align-items-center justify-content-start fx-flex-100 mb-16">
      <span class="title bold">{{ ('CASE.PHASE_' + status) | translate }}</span>
      <div class="chip main ml-10">{{ casesByState[status].length || 0 }}</div>
    </div>
    <div class="scroll-container fx-flex-100">
      <app-case-card *ngFor="let case of casesByState[status]" [case]="case" [color]="'white'"
        class="mb-10 fx-flex-100"></app-case-card>
      <span class="text light" *ngIf="!casesByState[status] || casesByState[status].length === 0">
        {{ ('CASES_LIST.NO_' + status + '_CASE') | translate }}
      </span>
    </div>
  </div>
</div>
<app-empty-placeholder *ngIf="!loading && done && noDocs" roleBasedElement [roles]="['SUPERADMIN', 'ADMIN', 'MANAGER']"
  class="fx-flex" [offset]="125" [title]="'CASES_LIST.NO_CASES'" [message]="'CASES_LIST.NO_CASES_MESSAGE'"
  [button]="noCaseButton"></app-empty-placeholder>
<app-empty-placeholder *ngIf="!loading && done && noDocs" class="fx-flex" [offset]="125"
  [title]="'HOME.CASE_OPERATOR_NO_CASES'" [message]="'HOME.CASE_OPERATOR_NO_CASES_MESSAGE'" roleBasedElement
  [roles]="['CASE_OPERATOR']"></app-empty-placeholder>